import classNames from 'classnames';
import React, { useContext, useState } from 'react';

import { ArrowAngleDown, ArrowAngleUp } from '@zooplus/icons';
import { Anchor } from '@zooplus/ui-components';

import AppContext from '../../context';
import { UiCategory } from '../../types';
import { isSpecialLink } from '../../utils/categoryUtils';
import { ThemedIcon } from '../Icon/Icon';
import { LinkTypeEnum } from '../Link/Link';

import styles from './CategoryFlyout.module.scss';

const MAX_LINKS_SHOWN = 6;

export const ExpandableCategoryList = ({
    categories,
}: {
    categories: UiCategory[];
}) => {
    const [showAll, setShowAll] = useState(false);

    const handleToggle = () => {
        setShowAll(!showAll);
    };

    const { translations } = useContext(AppContext);
    const labels = {
        showMore: translations.get('general.show-more'),
        showLess: translations.get('general.show-less'),
    };

    return (
        <>
            {categories.map((item, index) => {
                const isSpecial = isSpecialLink(item);
                return (
                    <li
                        key={item.path}
                        className={classNames(styles.groupItem, {
                            [styles.groupItemHidden]:
                                index >= MAX_LINKS_SHOWN && !showAll,
                        })}>
                        <Anchor
                            variant={
                                isSpecial ? 'danger' : LinkTypeEnum.NEUTRAL
                            }
                            data-link-type={
                                isSpecial
                                    ? LinkTypeEnum.OFFER
                                    : LinkTypeEnum.NEUTRAL
                            }
                            className={classNames(
                                {
                                    [styles.nonBoldSpecialsText]: isSpecial,
                                },
                                styles.subSpecialOffers,
                            )}
                            data-zta="category-flyout-animal-level4-link"
                            aria-hidden={index >= MAX_LINKS_SHOWN && !showAll}
                            aria-label="group-item"
                            href={item.path}>
                            {item.title}
                        </Anchor>
                    </li>
                );
            })}
            {categories.length > MAX_LINKS_SHOWN && (
                <li className={styles.groupFooter}>
                    <Anchor
                        onClick={handleToggle}
                        iconRight={() => (
                            <ThemedIcon
                                color="primary"
                                Icon={showAll ? ArrowAngleUp : ArrowAngleDown}
                                aria-label={
                                    showAll ? labels.showMore : labels.showLess
                                }
                            />
                        )}>
                        {showAll ? labels.showLess : labels.showMore}
                    </Anchor>
                </li>
            )}
        </>
    );
};
